import { COOKIE, EVENT_NAME } from '../config.js';
import { debug } from './debug.js';
import { SID_STORE_CHECK as STORE_CHECK } from '@sklik/cmp2-common';
import { COOKIE as COOKIE_UTILS } from '@iva/utils';
/**
 * Returns the domain name that will be set in the cookie.
 * @return {String} Domain name.
 */
const getDomain = () => {
    const isTld = (hostname) => !hostname.includes('.');
    const { hostname } = window.location;
    return (isTld(hostname) ? '' : '.') + hostname.split('.').slice(-2).join('.');
};
/**
 * Sets cookie with the given value.
 * @param {String} value - Value to be saved into the cookie.
 */
export const setCookie = (value) => {
    // store as 1st party cookie
    const date = new Date();
    date.setTime(date.getTime() + COOKIE.EXPIRACY_DAYS * COOKIE.INTERVAL_24);
    const domain = getDomain();
    const secure = window.location.protocol === 'https:';
    COOKIE_UTILS.setCookie(COOKIE.NAME, value, {
        path: '/',
        domain,
        secure,
        expires: date.toUTCString(),
    });
};
/**
 * Sets udid cookie with the given value + report by CustomEvent
 */
const setUdidAndDispatchEvent = (value) => {
    setCookie(value);
    let onlyUdid = value;
    const udidValueSplit = value.split('@');
    if (udidValueSplit.length === 2 && udidValueSplit[0]?.length === 36) {
        onlyUdid = udidValueSplit[0];
    }
    if (window.sznIVA?.IS) {
        window.sznIVA.IS.updateIdentities({ udid: onlyUdid });
    }
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: onlyUdid }));
    debug({ message: 'Final mark has been saved into browser.' });
};
/**
 * Sets udid cookie and reports
 * Before storing it checks if it's legal when forceCookie is false
 */
export const setUdidCookieAndReport = (value, forceCookie) => {
    if (!value) {
        debug({ message: 'Final mark was not saved - missing value.' });
        return Promise.resolve();
    }
    // check if cookie creation should be forced
    if (forceCookie) {
        setUdidAndDispatchEvent(value);
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        // check if cookie can be legally stored before saving
        STORE_CHECK.sidLegalStoreCheck(() => {
            setUdidAndDispatchEvent(value);
            resolve();
        }, () => {
            debug({ message: 'Final mark was not saved - missing consent.' });
            resolve();
        });
    });
};
